<template>
  <multi-selection-tool-button
    icon="mdi-playlist-remove"
    :icon-size="15"
    :disabled="disabled"
    :tooltip="tooltip"
    @click="$emit('click')"
  />
</template>

<script>
import MultiSelectionToolButton from "@/components/Home/Forms/_Atoms/TableToolbarButton";

export default {
  name: "HomeFormTableRemoveFromListTool",

  components: { MultiSelectionToolButton },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    tooltip: {
      type: String,
      required: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Atoms/TableToolbarButtons/RemoveFromList.vue